import { render, staticRenderFns } from "./TopModal.component.vue?vue&type=template&id=4e31f90d&scoped=true&lang=pug"
import script from "./TopModal.component.vue?vue&type=script&lang=ts"
export * from "./TopModal.component.vue?vue&type=script&lang=ts"
import style0 from "./TopModal.component.vue?vue&type=style&index=0&id=4e31f90d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e31f90d",
  null
  
)

export default component.exports